import Ext from 'Ext'
import $ from 'jquery'
import DropdownButton from '../at_dropdown_button'
import {scrollWindowIfNeeded, getBodyScrollTop} from '../../atBrowserUtils'
/**
 * Dropdown button intended for use with selector panels.
 *
 * Depends on:
 * <code>/js/controls/at_dropdown_button.js</code>
 *
 * @cfg {AT.SelectorPanel} selectorPanel selector panel to be displayed in dropdown (required).
 * @constructor
 */
const SelectorDropdownButton = Ext.extend(DropdownButton, {

    /**
     * @cfg {Number} specifies selector panel height. Is used to adjust menu align properly whether it is drop UP or DOWN
     */
    selectorPanelHeight: 350,
    selectorPanel: null,
    labelCls: "ellipsis",
    cls: "dropdown-button at-selector-button",
    errorCls: "error",

    dropDownMenuAnchor: "td.bottom-left-cell",
    dropUpMenuAnchor: "td.top-left-cell",

    constructor: function(config) {
        var menuCls = "at-selector-menu";
        if( config.additionalMenuCls )
            menuCls += " " + config.additionalMenuCls;

        this.menu = new Ext.menu.Menu(
                {
                    shadow : config.isNoShadow === true ? false : "sides",
                    cls: menuCls,
                    items: [ config.selectorPanel ],
                    show: function(el, pos, parentMenu) {
                        Ext.menu.Menu.prototype.show.call(this, el, pos, parentMenu);
                        var diff = this.el.getBottom() - (getBodyScrollTop() + document.body.clientHeight);
                        if (diff > 0) {
                            Ext.getBody().scroll("down", diff);
                        }
                    }
                });

        SelectorDropdownButton.superclass.constructor.call(this, config);
    },

    initComponent: function() {
        SelectorDropdownButton.superclass.initComponent.call(this);

        this.selectorPanel.on("change", this.updateButton, this);
        this.selectorPanel.on("close", this.menu.hide, this.menu);

        Ext.EventManager.on(window, "resize", this.menu.hide, this.menu);

        this.on("menuhide", function()
        {
            this.selectorPanel.markAllSelectedIfNeeded();
        });

        this.updateButton();
    },

    afterRender: function() {
        SelectorDropdownButton.superclass.afterRender.call(this);
        this.el.child("span:first").addClass(this.labelCls);
    },

    /**
     * Updates text label on the button.
     * @private
     */
    updateButton: function() {
        this.setText(this.selectorPanel.getLabelText());
        this.setDisplayInputError(false);
        this.setTooltipEnabled(this.selectorPanel.isTooltipEnabled());
    },

    showMenu: function()
    {
        var dropDownAnchor = this.el.child(this.dropDownMenuAnchor);
        var dropUpAnchor = this.el.child(this.dropUpMenuAnchor);
        var yShift = dropDownAnchor.getTop() - dropUpAnchor.getTop();
        var enoughTopSpace = ( dropUpAnchor.getTop() - this.selectorPanelHeight ) > 0;
        this.menuAnchor = (enoughTopSpace) ? this.dropDownMenuAnchor : this.dropUpMenuAnchor;

        SelectorDropdownButton.superclass.showMenu.call(this);

        var element = this.menu.el;
        var topLeft = element.getXY();

        if (this.menuAnchor === this.dropUpMenuAnchor && ( element.getBottom() > dropDownAnchor.getBottom()))
            topLeft[1] += yShift;
        if (this.menuAnchor === this.dropDownMenuAnchor && ( element.getTop() < dropUpAnchor.getTop()))
            topLeft[1] -= yShift;

        var customShifty = $( this.container.dom ).attr( "dropdown-menu-shift-y" );
        if ( customShifty )
            topLeft[1] += parseInt( customShifty );

        element.setXY( topLeft );
        scrollWindowIfNeeded( element.dom );
    }

});

Ext.namespace("AT");

Ext.reg("at_selector_dropdown_button", SelectorDropdownButton);

export default SelectorDropdownButton



// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/at_selector_dropdown_button.js